import { render, staticRenderFns } from "./indexHeader.vue?vue&type=template&id=10809f1b&scoped=true"
import script from "./indexHeader.vue?vue&type=script&lang=js"
export * from "./indexHeader.vue?vue&type=script&lang=js"
import style0 from "./indexHeader.vue?vue&type=style&index=0&id=10809f1b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10809f1b",
  null
  
)

export default component.exports